"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProjectPreview = _interopRequireDefault(require("./ProjectPreview"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ".project-previews {\n  margin-bottom: 16px;\n  padding: 0 1rem; }\n  .project-previews .bx--grid {\n    padding: 0px; }\n";
  const fileName = "ValueAppProjectList_ValueAppProjectList";
  const element = document.querySelector("style[data-sass-component='ValueAppProjectList_ValueAppProjectList']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ValueAppProjectList = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'project-previews'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'bx--grid bx--grid--narrow'
  }, props.items.map((item, index) => {
    item.Component = props.elementToRender;
    return /*#__PURE__*/_react.default.createElement(_ProjectPreview.default, _extends({
      key: index
    }, item));
  })));
};
ValueAppProjectList.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    tags: _propTypes.default.object.isRequired,
    date: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired,
    translate: _propTypes.default.func.isRequired,
    logo: _propTypes.default.string,
    name: _propTypes.default.string,
    published: _propTypes.default.bool,
    onClickUnpublished: _propTypes.default.func
  })).isRequired,
  elementToRender: _propTypes.default.elementType.isRequired
};
var _default = exports.default = ValueAppProjectList;